import React from "react";
import {Container} from "react-bootstrap";

const mawbRe = /\d{11}/
export default class Report extends React.Component {
    state = {
        alert: '',
        mawbs: '',
        isDownloading: false,
    };

    render() {
        const alert = this.state.alert;
        return (
            <Container>
                <h4 className="mt-4">REPORT</h4>
                {alert
                    ? <div className="alert alert-danger">{alert}</div>
                    : <div className="alert alert-danger invisible">&nbsp;</div>
                }
                <form onSubmit={this.download}>
                    <div className="form-group">
                        <label htmlFor="txt">MAWBS (comma separated)</label>
                        <textarea
                            className="form-control" id="txt" rows="3"
                            placeholder="02020115734, 02020115756"
                            value={this.state.mawbs}
                            onChange={e => {
                                const v = e.currentTarget.value;
                                this.setState({mawbs: v});
                            }}
                        >
                        </textarea>
                    </div>
                    <button
                        type="submit" className="btn btn-primary"
                        disabled={this.state.isDownloading}
                    >
                        Download
                    </button>
                </form>
            </Container>
        )
    }

    download = (e) => {
        e.preventDefault();
        this.setState({
            isDownloading: true,
            alert: '',
        })

        let mawbs = [];
        for (const p of this.state.mawbs.split(',')) {
            let m = p.trim();
            if (!m.match(mawbRe)) {
                this.setState({
                    isDownloading: false,
                    alert: `'${m}' must have 11 digits, got ${m.length}`,
                })
                return
            }
            mawbs.push(m);
        }
        const t = localStorage.getItem('token')
        const m = mawbs.join(',')
        const url = `/api/v1/admin/mawb-report?mawbs=${m}&token=${t}`
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    this.setState({alert: `HTTP error: ${response.status}`})
                } else {
                    response.text()
                        .then(data => {
                            const a = document.createElement("a");
                            a.style.display = "none";
                            document.body.appendChild(a);
                            const blob = new Blob([data], {type: "text/csv"});
                            const url = window.URL.createObjectURL(blob);
                            a.href = url;
                            a.download = "report.csv";
                            a.click();
                            window.URL.revokeObjectURL(url);
                            a.remove();
                            this.setState({mawbs: ''})
                        })
                }
            })
            .catch((e) => {
                this.setState({alert: JSON.stringify(e)})
            })
            .finally(_ => {
                this.setState({isDownloading: false})
            })
    }
}
